import React, { useCallback, useEffect, useState } from 'react'
import { Button, Card, Col, Form, Row, Table } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { useCookies } from 'react-cookie'
import { getMoneyLogMismatches, lookupMoneyLog } from '../../../controller/api/moneyLogLink'
import Pagination from '../../../components/Pagination'
import { Routes } from '../../../routes'

const PAGE_SIZE = 10

const SOURCE_TYPES = [
  { value: 'charge-auto', label: 'Nạp tự động' },
  { value: 'charge-manual', label: 'Nạp thủ công' },
  { value: 'refund', label: 'Thu hồi' },
  { value: 'bonus', label: 'Thưởng người mới' },
  { value: 'cashback-cancel', label: 'Hoàn tiền mua chung vì hủy nhóm' },
  { value: 'cashback-excess', label: 'Hoàn phần tiền dư của mua chung' },
  { value: 'cashback-classic', label: 'Hoàn tiền kiến thiết' },
  { value: 'cashback-vietlott', label: 'Hoàn tiền Vietlott' },
  { value: 'cashback-loto', label: 'Hoàn tiền loto' },
  { value: 'withdraw-internal', label: 'Rút về ví chính' },
  { value: 'withdraw-banking', label: 'Rút về ngân hàng' },
  { value: 'withdraw-cancel-internal', label: 'Hủy rút về ví chính' },
  { value: 'withdraw-cancel-banking', label: 'Hủy rút về ngân hàng' },
  { value: 'buy-vietlott', label: 'Mua vé Vietlott' },
  { value: 'buy-kt', label: 'Mua vé kiến thiết' },
  { value: 'buy-lt', label: 'Mua vé loto' },
  { value: 'buy-group', label: 'Mua chung' },
  { value: 'reward-vietlott', label: 'Trả thưởng Vietlott' },
  { value: 'reward-kt', label: 'Trả thưởng kiến thiết' },
  { value: 'reward-lt', label: 'Trả thưởng loto' },
]

const MISMATCH_REASONS = [
  'Có lệnh nhưng không có dòng tiền',
  'Có dòng tiền nhưng không có lệnh',
  'Dòng tiền còn, nhưng lệnh không còn',
  'Lệnh đang gắn nhầm dòng tiền khác',
  'Lệnh chưa gắn dòng tiền này',
  'Lệnh đang trỏ tới dòng tiền đã mất',
  'Dòng tiền không thuộc lệnh này',
]

function formatAmount(value) {
  if (value === null || value === undefined || value === '') {
    return ''
  }
  return new Intl.NumberFormat('vn-VI', {}).format(value)
}

function formatPhone(phone) {
  if (!phone) {
    return ''
  }
  return phone.replace('+84', '0')
}

function UserCell({ name, phone }) {
  return (
    <td>
      {name || 'Không rõ tên'}<br />
      <strong className="text-primary">{formatPhone(phone) || 'Không có số điện thoại'}</strong>
    </td>
  )
}

function queryValue(value) {
  return encodeURIComponent(JSON.stringify(value))
}

function orderPath(product, cartId) {
  const query = `cartId=${queryValue(cartId)}`
  if (product === 'vietlott') {
    return `${Routes.VietlottTicket.path}?${query}`
  }
  if (product === 'classic') {
    return `${Routes.ClassicTicket.path}?${query}`
  }
  if (product === 'loto') {
    return `${Routes.LotoSearch.path}?${query}`
  }
  if (product === 'group') {
    return Routes.VietlottGroupDetail.path.replace(':id', cartId)
  }
  return ''
}

function rowKey(item) {
  return `${item.wallet}-${item.logId}-${item.ref}-${item.reason}`
}

function CompareSides({ lookup }) {
  if (!lookup) {
    return <div className="text-muted">Đang tải đối soát</div>
  }
  return (
    <Row>
      <Col md={6}>
        <h6>Dòng tiền</h6>
        {(lookup.logs || []).length === 0 ? <div className="text-warning">Không thấy dòng tiền</div> : (
          <Table responsive bordered size="sm" className="mb-0 bg-white">
            <thead>
              <tr>
                <th>Người chơi</th>
                <th>Ví</th>
                <th>Loại</th>
                <th>Số tiền</th>
                <th>Thời gian</th>
              </tr>
            </thead>
            <tbody>
              {lookup.logs.map((item) => (
                <tr key={`${item.wallet}-${item.id}`}>
                  <UserCell name={item.userName} phone={item.userPhone} />
                  <td>{item.walletLabel}</td>
                  <td>
                    {item.kindLabel || item.sourceLabel}
                    <OrderActions product={item.product} cartId={item.cartId} />
                  </td>
                  <td>{formatAmount(item.amount)}</td>
                  <td>{item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss') : ''}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Col>
      <Col md={6}>
        <h6>Lệnh</h6>
        {(lookup.documents || []).length === 0 ? <div className="text-warning">Không thấy lệnh</div> : (
          <Table responsive bordered size="sm" className="mb-0 bg-white">
            <thead>
              <tr>
                <th>Người chơi</th>
                <th>Loại</th>
                <th>Ví chính</th>
                <th>Ví thưởng</th>
              </tr>
            </thead>
            <tbody>
              {lookup.documents.map((item) => (
                <tr key={`${item.type}-${item.id}`}>
                  <UserCell name={item.userName} phone={item.userPhone} />
                  <td>
                    {item.kindLabel || item.sourceLabel}
                    <div className="small text-break">Mã lệnh: {item.id}</div>
                    <OrderActions product={item.product} cartId={item.cartId} />
                  </td>
                  <td>{item.mainWallet}</td>
                  <td>{item.rewardWallet}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Col>
    </Row>
  )
}

function OrderActions({ product, cartId }) {
  if (!product || !cartId) {
    return null
  }
  const orderTo = orderPath(product, cartId)
  if (!orderTo) {
    return null
  }
  return (
    <div className="mt-2">
      <div className="small text-break">Mã đơn: {cartId}</div>
      <Button as={Link} to={orderTo} target="_blank" size="sm" variant="info" className="mt-1">Tra cứu đơn</Button>
    </div>
  )
}

export default function MoneyLogLink() {
  const [cookies] = useCookies(['lottmekong'])
  const [mismatches, setMismatches] = useState([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [query, setQuery] = useState('')
  const [month, setMonth] = useState(String(moment().month() + 1))
  const [year, setYear] = useState(String(moment().year()))
  const [userText, setUserText] = useState('')
  const [sourceType, setSourceType] = useState('')
  const [reason, setReason] = useState('')
  const [lookup, setLookup] = useState(null)
  const [openKey, setOpenKey] = useState('')
  const [detailByKey, setDetailByKey] = useState({})

  const loadMismatches = useCallback(async (filter) => {
    setLoading(true)
    try {
      const response = await getMoneyLogMismatches(cookies.lottmekong, {
        month: Number(filter && filter.month),
        year: Number(filter && filter.year),
        user: (filter && filter.user) || '',
        kind: (filter && filter.kind) || '',
        reason: (filter && filter.reason) || '',
      })
      setMismatches(response.data || [])
      setPage(0)
      setOpenKey('')
    } finally {
      setLoading(false)
    }
  }, [cookies.lottmekong])

  useEffect(() => {
    loadMismatches({ month: moment().month() + 1, year: moment().year() })
  }, [loadMismatches])

  const onLookup = async (event) => {
    event.preventDefault()
    const id = query.trim()
    if (!id) {
      return
    }
    const response = await lookupMoneyLog(cookies.lottmekong, id)
    setLookup(response)
  }

  const onToggleDetail = async (item) => {
    const key = rowKey(item)
    if (openKey === key) {
      setOpenKey('')
      return
    }
    setOpenKey(key)
    if (detailByKey[key]) {
      return
    }
    const response = await lookupMoneyLog(cookies.lottmekong, item.ref || item.logId)
    setDetailByKey((current) => ({
      ...current,
      [key]: response,
    }))
  }

  const totalPage = mismatches.length === 0 ? 0 : Math.ceil(mismatches.length / PAGE_SIZE)
  const pageItems = mismatches.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE)

  return (
    <>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <h5 className="mb-0">Tra cứu một lệnh</h5>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={onLookup}>
            <Row className="align-items-end">
              <Col md={8}>
                <Form.Label>Mã lệnh hoặc mã dòng tiền</Form.Label>
                <Form.Control
                  value={query}
                  onChange={(event) => setQuery(event.target.value)}
                  placeholder="Dán mã lệnh nạp, rút, mua vé hoặc mã dòng tiền"
                />
              </Col>
              <Col md={4}>
                <Button type="submit" variant="primary">Xem hai phía</Button>
              </Col>
            </Row>
          </Form>
          {lookup && (
            <div className="mt-4">
              <CompareSides lookup={lookup} />
            </div>
          )}
        </Card.Body>
      </Card>

      <Card border="light" className="shadow-sm">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Lệnh bị lệch ({mismatches.length})</h5>
          <Button size="sm" variant="secondary" onClick={() => loadMismatches({ month, year, user: userText, kind: sourceType, reason })} disabled={loading}>
            {loading ? 'Đang tải' : 'Tải lại'}
          </Button>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={(event) => {
            event.preventDefault()
            loadMismatches({ month, year, user: userText, kind: sourceType, reason })
          }}>
            <Row className="align-items-end">
              <Col md={2}>
                <Form.Label>Tháng</Form.Label>
                <Form.Control
                  type="number"
                  min={1}
                  max={12}
                  value={month}
                  onChange={(event) => setMonth(event.target.value)}
                  placeholder="1-12"
                />
              </Col>
              <Col md={2}>
                <Form.Label>Năm</Form.Label>
                <Form.Control
                  type="number"
                  min={2000}
                  max={2100}
                  value={year}
                  onChange={(event) => setYear(event.target.value)}
                  placeholder="yyyy"
                />
              </Col>
              <Col md={3}>
                <Form.Label>Người chơi</Form.Label>
                <Form.Control
                  value={userText}
                  onChange={(event) => setUserText(event.target.value)}
                  placeholder="Tên hoặc số điện thoại"
                />
              </Col>
              <Col md={3}>
                <Form.Label>Loại</Form.Label>
                <Form.Select value={sourceType} onChange={(event) => setSourceType(event.target.value)}>
                  <option value="">Tất cả</option>
                  {SOURCE_TYPES.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={3}>
                <Form.Label>Loại lệch</Form.Label>
                <Form.Select value={reason} onChange={(event) => setReason(event.target.value)}>
                  <option value="">Tất cả</option>
                  {MISMATCH_REASONS.map((item) => (
                    <option key={item} value={item}>{item}</option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
            <div className="mt-3">
              <Button type="submit" variant="info" disabled={loading}>Lọc</Button>
            </div>
          </Form>
        </Card.Body>
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className="text-center">
            <tr>
              <th>Thao tác</th>
              <th>Người chơi</th>
              <th>Ví</th>
              <th>Loại</th>
              <th>Tình trạng</th>
              <th>Số tiền</th>
              <th>Thời gian</th>
            </tr>
          </thead>
          <tbody>
            {pageItems.map((item) => {
              const key = rowKey(item)
              const opened = openKey === key
              return (
                <React.Fragment key={key}>
                  <tr>
                    <td className="text-center">
                      <Button
                        variant={opened ? 'primary' : 'light'}
                        size="sm"
                        onClick={() => onToggleDetail(item)}
                        title={opened ? 'Ẩn đối soát' : 'Xem đối soát'}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </Button>
                    </td>
                    <UserCell name={item.userName} phone={item.userPhone} />
                    <td>{item.walletLabel}</td>
                    <td>
                      {item.kindLabel || item.sourceLabel}
                      <div className="small text-break">Mã lệnh: {item.ref}</div>
                      <OrderActions product={item.product} cartId={item.cartId} />
                    </td>
                    <td className="text-danger">{item.reason}</td>
                    <td>{formatAmount(item.amount)}</td>
                    <td>{item.createdAt && new Date(item.createdAt).getTime() > 0 ? moment(item.createdAt).format('DD/MM/YYYY HH:mm') : ''}</td>
                  </tr>
                  {opened && (
                    <tr>
                      <td colSpan={7} className="bg-light">
                        <CompareSides lookup={detailByKey[key]} />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              )
            })}
            {!loading && pageItems.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center">Không có lệnh lệch trong tháng {month}/{year}</td>
              </tr>
            )}
          </tbody>
        </Table>
        <Card.Footer>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={totalPage}
                currentPage={page}
                onPageChange={(nextPage) => {
                  setPage(nextPage)
                  setOpenKey('')
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  )
}
